import { Card, Col, Form, Input, Radio, Row, Space, Typography } from "antd";
import React, { useEffect, useMemo, useCallback } from "react";
import { useTranslation } from "react-i18next";
const { Title } = Typography;

const PatientAddressFields = ({ getChildData, validationRules, form }) => {
  const { t } = useTranslation();
  const callparent = (e, name) => {
    getChildData(e, name);
  };

  return (
    <>
      <Col xs={24} md={12}>
        <Form.Item
          label={t("patientDetailsFMLS:address_line_1")}
          name="RecipientAddress1"
          onChange={(e) => callparent(e.target.value, "RecipientAddress1")}
          rules={validationRules.address1}
          required
        >
          <Input maxLength={150} />
        </Form.Item>
      </Col>
      <Col xs={24} md={12}>
        <Form.Item
          label={t("patientDetailsFMLS:address_line_2")}
          name="RecipientAddress2"
          onChange={(e) => callparent(e.target.value, "RecipientAddress2")}
        >
          <Input maxLength={150} />
        </Form.Item>
      </Col>
      <Col xs={24} md={12}>
        <Form.Item
          label={t("patientDetailsFMLS:city")}
          name="RecipientCity"
          onChange={(e) => callparent(e.target.value, "RecipientCity")}
          required
          rules={validationRules.city}
        >
          <Input maxLength={50} />
        </Form.Item>
      </Col>
      <Col xs={24} md={12}>
        <Form.Item
          label={t("patientDetailsFMLS:state")}
          name="RecipientState"
          onChange={(e) => callparent(e.target.value, "RecipientState")}
          required
          rules={validationRules.state}
        >
          <Input maxLength={50} />
        </Form.Item>
      </Col>
      <Col xs={24} md={12}>
        <Form.Item
          label={t("patientDetailsFMLS:zip_code")}
          name="RecipientZipCode"
          onChange={(e) => callparent(e.target.value, "RecipientZipCode")}
          required
          rules={validationRules.zipCode}
        >
          <Input maxLength={8} />
        </Form.Item>
      </Col>
    </>
  );
};

const RequesterAddressFields = ({ getChildData, validationRules, form }) => {
  const { t } = useTranslation();
  const callparent = (e, name) => {
    getChildData(e, name);
  };

  return (
    <>
      <Col xs={24} md={12}>
        <Form.Item
          className="font-medium"
          name="RecipientAddress1"
          label={t("bulkRequest:address_line_1")}
          onChange={(e) => callparent(e.target.value, "RecipientAddress1")}
          rules={validationRules.address1}
        >
          <Input maxLength={150} />
        </Form.Item>
      </Col>
      <Col xs={24} md={12}>
        <Form.Item
          className="font-medium"
          name="RecipientAddress2"
          onChange={(e) => callparent(e.target.value, "RecipientAddress2")}
          label={t("bulkRequest:address_line_2")}
        >
          <Input maxLength={150} />
        </Form.Item>
      </Col>
      <Col xs={24} md={12}>
        <Form.Item
          name="RecipientCity"
          label={t("bulkRequest:city")}
          onChange={(e) => callparent(e.target.value, "RecipientCity")}
          rules={validationRules.city}
        >
          <Input maxLength={50} />
        </Form.Item>
      </Col>
      <Col xs={24} md={12}>
        <Form.Item
          name="RecipientState"
          label={t("bulkRequest:state")}
          onChange={(e) => callparent(e.target.value, "RecipientState")}
          rules={validationRules.state}
        >
          <Input maxLength={50} />
        </Form.Item>
      </Col>
      <Col xs={24} md={12}>
        <Form.Item
          name="RecipientZipCode"
          label={t("bulkRequest:zip_code")}
          onChange={(e) => callparent(e.target.value, "RecipientZipCode")}
          required
          rules={validationRules.zipCode}
        >
          <Input maxLength={8} />
        </Form.Item>
      </Col>
    </>
  );
};

const Recipient = ({ getChildData, patientDetailsData, form }) => {
  const { t, i18n } = useTranslation();
  const isPatient = patientDetailsData?.IsPatient?.toString() === "yes";
  const callparent = (e, name) => {
    getChildData(e, name);
  };

  useEffect(() => {
    if (!patientDetailsData?.RecipientMethodOfRelease) return;
    if (patientDetailsData.RecipientMethodOfRelease !== "mail") return;

    form.resetFields(["RecipientAddress1", "RecipientAddress2", "RecipientCity", "RecipientState", "RecipientZipCode"]);

    if (isPatient) {
      form.setFieldsValue({
        RecipientAddress1: patientDetailsData.PAddLine1 || "",
        RecipientAddress2: patientDetailsData.PAddLine2 || "",
        RecipientCity: patientDetailsData.PCity || "",
        RecipientState: patientDetailsData.PState || "",
        RecipientZipCode: patientDetailsData.PZipCode || "",
      });
    } else {
      form.setFieldsValue({
        RecipientAddress1: patientDetailsData.RequesterAddLine1 || "",
        RecipientAddress2: patientDetailsData.RequesterAddLine2 || "",
        RecipientCity: patientDetailsData.RequesterCity || "",
        RecipientState: patientDetailsData.RequesterState || "",
        RecipientZipCode: patientDetailsData.RequesterZipCode || "",
      });
    }
  }, [
    patientDetailsData?.IsPatient,
    patientDetailsData?.RecipientMethodOfRelease,
    form,
  ]);

  useEffect(() => {
    if (patientDetailsData.recordsDisclose == "self") {
      let res =
        patientDetailsData.IsPatient == "yes"
          ? patientDetailsData.PFirstName + " " + patientDetailsData.PLastName
          : patientDetailsData.RequesterFName +
            " " +
            patientDetailsData.RequesterLName;

      let phone =
        patientDetailsData.IsPatient == "yes"
          ? patientDetailsData.PatientPhoneNumber
          : patientDetailsData.RequesterPhoneNumber;

      let email =
        patientDetailsData.IsPatient == "yes"
          ? patientDetailsData.PEmail
          : patientDetailsData.RequesterEmail;

      form.setFieldsValue({
        nameorganization: res,
        rphone: phone,
        remail: email,
      });
    }
  }, [patientDetailsData.IsPatient]);

  const onChangeRadio = (e) => {
    getChildData(e.target.value, "RecipientDiscloseRecordsTo");
    if (e.target.value == "self") {
      let res =
        patientDetailsData.IsPatient == "yes"
          ? patientDetailsData.PFirstName + " " + patientDetailsData.PLastName
          : patientDetailsData.RequesterFName +
            " " +
            patientDetailsData.RequesterLName;

      let phone =
        patientDetailsData.IsPatient == "yes"
          ? patientDetailsData.PatientPhoneNumber
          : patientDetailsData.RequesterPhoneNumber;

      let email =
        patientDetailsData.IsPatient == "yes"
          ? patientDetailsData.PEmail
          : patientDetailsData.RequesterEmail;

      form.setFieldsValue({
        nameorganization: res,
        rphone: phone,
        remail: email,
      });
    } else {
      form.setFieldsValue({
        nameorganization: "",
        rphone: "",
        remail: "",
        vemail: "",
      });
    }
  };

  const validatePhone = useCallback(
    (_, value) => {
      const phoneRegex = /^[+]?[0-9]{10,15}$/;
      if (!value || phoneRegex.test(value)) {
        return Promise.resolve();
      }
      return Promise.reject(
        new Error(t("patientDetails:please_enter_a_valid_phone_number"))
      );
    },
    [t]
  );

  const validateConfirmEmail = useCallback(
    (_, value) => {
      const email = form.getFieldValue("remail");
      if (value && value !== email) {
        return Promise.reject(
          new Error(t("patientDetails:verify_email_does_not_match_with_email"))
        );
      }
      return Promise.resolve();
    },
    [form, t]
  );

  const validationRules = useMemo(
    () => ({
      required: [
        {
          required: true,
          message: t("patientDetails:please_choose_any_option"),
        },
      ],
      nameOrganization: [
        {
          required: true,
          max: 110,
          message: t("patientDetails:please_enter_name_or_organization"),
        },
      ],
      email: [
        {
          required: true,
          max: 100,
          message: t("patientDetails:please_enter_email"),
        },
        {
          type: "email",
          message: t("patientDetails:please_enter_valid_email"),
        },
      ],
      verifyEmail: [
        {
          required: true,
          max: 100,
          message: t("patientDetails:please_enter_email"),
        },
        { validator: validateConfirmEmail },
      ],
      faxNumber: [
        {
          required: true,
          max: 20,
          message: t("patientDetails:please_enter_fax_number"),
        },
      ],
      phone: [
        {
          required: true,
          max: 20,
          message: t("patientDetails:please_enter_phone_number"),
        },
        { validator: validatePhone },
      ],
      address1: [
        {
          required: true,
          max: 150,
          message: t("patientDetails:please_enter_address"),
        },
      ],
      address2: [
        {
          required: true,
          max: 150,
          message: t("patientDetails:please_enter_address"),
        },
      ],
      city: [
        {
          required: true,
          max: 50,
          message: t("patientDetails:please_enter_city_name"),
        },
      ],
      state: [
        {
          required: true,
          message: t("patientDetails:please_enter_state_name"),
        },
      ],
      zipCode: [
        {
          required: true,
          max: 8,
          message: t("patientDetails:please_enter_zip_code"),
        },
      ],
    }),
    [t, validatePhone, validateConfirmEmail]
  );

  return (
    <Card
      bordered={false}
      size="0"
      title={
        <Title
          className="font-semibold"
          style={{ marginBottom: "0" }}
          level={4}
        >
          {t("patientDetails:recipient_information")}
        </Title>
      }
    >
      <Form.Item
        className="font-medium"
        name="discloserecord"
        label={t(
          "patientDetails:who_would_you_like_to_disclose_the_records_to"
        )}
        required
        rules={validationRules.required}
      >
        <Radio.Group onChange={onChangeRadio}>
          <Space direction="vertical" className="ms-4">
            <Radio value="self" className="font-normal">
              {t("patientDetails:self")}
            </Radio>
            <Radio value="insurance" className="font-normal">
              {t("patientDetails:insurance")}
            </Radio>
            <Radio value="attorney" className="font-normal">
              {t("patientDetails:attorney")}
            </Radio>
            <Radio value="physician" className="font-normal">
              {t("patientDetails:physician")}
            </Radio>
            <Radio value="other" className="font-normal">
              {t("patientDetails:other")}
            </Radio>
          </Space>
        </Radio.Group>
      </Form.Item>
      <Form.Item
        className="font-medium"
        label={t("patientDetails:what_method_of_release_would_you_like")}
        required
        name="releasemethod"
        rules={validationRules.required}
      >
        <Radio.Group
          onChange={(e) => {
            callparent(e.target.value, "RecipientMethodOfRelease");
          }}
          value={patientDetailsData.RecipientMethodOfRelease}
        >
          <Space direction="vertical" className="ms-4">
            <Radio value="email" className="font-normal">
              {t("patientDetails:email")}
            </Radio>
            <Radio value="fax" className="font-normal">
              {t("patientDetails:fax")}
            </Radio>
            <Radio value="mail" className="font-normal">
              {t("patientDetails:mail")}
            </Radio>
          </Space>
        </Radio.Group>
      </Form.Item>

      {patientDetailsData.RecipientMethodOfRelease.toString() && (
        <Row gutter={[20, 0]} className="mt-4">
          <Col xs={24} md={12}>
            <Form.Item
              className="font-medium"
              label={t("patientDetails:name_organization")}
              onChange={(e) => callparent(e.target.value, "RecipientName")}
              required
              name="nameorganization"
              rules={validationRules.nameOrganization}
            >
              <Input maxLength={110} />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}></Col>
          {patientDetailsData.RecipientMethodOfRelease.toString() ===
          "email" ? (
            <>
              <Col xs={24} md={12}>
                <Form.Item
                  className="font-medium"
                  label={t("patientDetails:recipient_email")}
                  onChange={(e) => callparent(e.target.value, "RecipientEmail")}
                  required
                  name="remail"
                  rules={validationRules.email}
                >
                  <Input maxLength={100} />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name="vemail"
                  className="font-medium"
                  label={t("patientDetails:verify_email")}
                  onChange={(e) =>
                    callparent(e.target.value, "RecipientVerifyEmail")
                  }
                  rules={validationRules.verifyEmail}
                >
                  <Input maxLength={100} />
                </Form.Item>
              </Col>
            </>
          ) : patientDetailsData.RecipientMethodOfRelease?.toString() ===
            "mail" ? (
            <>
              {isPatient ? (
                <PatientAddressFields
                  getChildData={getChildData}
                  validationRules={validationRules}
                  form={form}
                />
              ) : (
                <RequesterAddressFields
                  getChildData={getChildData}
                  validationRules={validationRules}
                  form={form}
                />
              )}
            </>
          ) : (
            <>
              <Col xs={24} md={12}>
                <Form.Item
                  className="font-medium"
                  label={t("patientDetails:fax_number")}
                  onChange={(e) => callparent(e.target.value, "RecipientFax")}
                  name="faxnumber"
                  rules={validationRules.faxNumber}
                >
                  <Input maxLength={20} />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  className="font-medium"
                  label={t("patientDetails:phone_number")}
                  onChange={(e) =>
                    callparent(e.target.value, "RecipientPhoneNumber")
                  }
                  required
                  name="phone"
                  rules={validationRules.phone}
                >
                  <Input maxLength={20} />
                </Form.Item>
              </Col>
            </>
          )}
        </Row>
      )}
    </Card>
  );
};
export default Recipient;
